// pages/index.js (or any other component where you want to use the data)

import Head from 'next/head';
import getContainerData from './container-data';
import React from 'react';
import styled from '@emotion/styled';

export const Content = styled.div`
  margin-top: 2rem;
`;
export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.6rem;
`;

export const ContentHeader = styled.div`
  display: flex;
`;
export const ContentHeaderText = styled.span`
  color: #2b4798;
  font-size: 16px;
  line-height: 1.6rem;
  font-weight: 600;
  margin-bottom: 1rem;
`;
export const ContentText = styled.p`
  color: #2b4798;
`;
const Container = (props) => {
  const containers = getContainerData();
  const { asPath } = props.router;
  const paragraph = containers.find((container) => container.name === asPath)?.paragraph || [];
  return (
    <>
      <Content>
        {paragraph.map((item, index) => (
          <ContentWrapper key={index}>
            {item?.title && (
              <ContentHeader>
                <ContentHeaderText>{item.title}</ContentHeaderText>
              </ContentHeader>
            )}

            <ContentText>
              {item.content.split('[').map((segment, segmentIndex) => {
                if (segment.includes(']')) {
                  const [indexStr, rest] = segment.split(']');
                  const urlIndex = parseInt(indexStr, 10);
                  if (!isNaN(urlIndex)) {
                    return (
                      <React.Fragment key={segmentIndex}>
                        <a href={item.canonicalUrls[urlIndex].url}>{item.canonicalUrls[urlIndex].name}</a>
                        <span>{rest}</span>
                      </React.Fragment>
                    );
                  }
                }
                return segment;
              })}
            </ContentText>
          </ContentWrapper>
        ))}
      </Content>
    </>
  );
};

export default Container;
